import { ESupplementalLoanRefusalReasons, Loader, SubmitRefinancingResultDto, useGetCanHaveSupplementalLoanDto, useGetRefinancingParams } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import RefinancingCreditApplicationForm from './RefinanceForm'

const RefinancingCreditApplicationContainer = () => {
  const params = useParams()
  const id = params.id!
  const { t } = useTranslation()

  const [refinanceParams, isLoadingRefinance] = useGetRefinancingParams(id, EFinancingProgram.Personal)
  const [canHaveSupplementalLoanDto, isFetchingCanHaveSupplementalLoanDto] = useGetCanHaveSupplementalLoanDto(id, EFinancingProgram.Personal)
  const [newAppInfo, setNewAppInfo] = useState<SubmitRefinancingResultDto | null>(null)

  if (isLoadingRefinance || isFetchingCanHaveSupplementalLoanDto)
    return <Loader title={t('common.withYouShortly')} description="" />

  const canHaveSupplementalLoan = canHaveSupplementalLoanDto?.canHaveSupplementalLoan

  const canHaveSupplementalLoanReasons = canHaveSupplementalLoanDto?.refusalReasonCodes

  const supplementalLoanOnGoing = canHaveSupplementalLoanReasons?.includes(
    ESupplementalLoanRefusalReasons.OnGoingCreditApplication,
  )

  return (
    <div>
      {!canHaveSupplementalLoan && (
        <main className="general-message">
          <h4 className="subtitle">{t('common.financeApplication')}</h4>
          <h3>{supplementalLoanOnGoing ? t('supplementalLoan.onGoingCreditApp') : t('refinancing.noRefinancing')}</h3>
          {supplementalLoanOnGoing && (
            <h1>
              {t('supplementalLoan.onGoingCreditAppReferenceNumber')}{' '}
              {canHaveSupplementalLoanDto?.ongoingApplicationReferenceNumber}.
            </h1>
          )}
        </main>
      )}
      {canHaveSupplementalLoan && !newAppInfo && refinanceParams && (
        <RefinancingCreditApplicationForm
          creditApplicationId={id}
          refinancingParams={refinanceParams}
          onSubmitted={setNewAppInfo}
        />
      )}

      {newAppInfo && (
        <main className="general-message">
          <h4 className="subtitle">{t('common.financeApplication')}</h4>
          <h1>
            #{newAppInfo.referenceNumber} {t('refinancing.confirmation.inReview')}
          </h1>
          <div className="paragraph">
            <p>{t('refinancing.confirmation.messageLine1')}.</p>
            <p>{t('refinancing.confirmation.messageLine2')}</p>
          </div>
        </main>
      )}
    </div>
  )
}

export default RefinancingCreditApplicationContainer
